import React, { ReactElement } from 'react'
import { ArrowRightCircleIcon } from '@heroicons/react/24/outline'
import Walkthrough from '../../../App/models/Walkthrough'
import ActionsSection from '../../../common/ui/ActionsSection'

interface Props {
  labsUrl: string
  walkthrough: Walkthrough
  cardMenu: ReactElement
  toggleEmbedModal?: () => void
}

const InternalStickyBarContent: React.FC<Props> = ({
  cardMenu,
  labsUrl,
  walkthrough,
  toggleEmbedModal,
}) => (
  <>
    <div className="sm:flex space-x-2 lg:space-x-4 hidden">
      {walkthrough.labs && (
        <a
          target="_blank"
          href={labsUrl}
          className="flex items-center justify-center px-2 py-2 border border-transparent rounded-md shadow-sm lg:text-sm sm:text-[12px] font-medium text-white hover:bg-ddu-orange-600 bg-ddu-orange-500"
          rel="noreferrer"
        >
          <div className="whitespace-nowrap">
            {' '}
            <span className="hidden lg:inline">Start</span> Labs Learning
          </div>
          <ArrowRightCircleIcon className="ml-1 h-4 w-4 hidden lg:block" />
        </a>
      )}
    </div>
    <div className="flex w-full relative lg:w-auto items-center mr-2 ml-2">
      <ActionsSection
        object={walkthrough}
        objectType="walkthrough"
        cardMenu={cardMenu}
        toggleEmbedModal={toggleEmbedModal}
      />
    </div>
  </>
)

export default InternalStickyBarContent
